export enum PAGE_MODE {
  REDIRECT = 'redirect',
  POPUP = 'popup',
}
